import React, { useEffect, useState } from "react";
import { Mail, Phone, MapPin, User } from "lucide-react";
import axios from "axios";
import Navbar from "./Navbar";
import { ArrowLeft } from "lucide-react";

import { useNavigate } from "react-router-dom";


const ChennaiProfile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const User_Id = localStorage.getItem("User_Id"); 

        if (!User_Id) {
          setError("User ID not found. Please log in again.");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `https://api.livestockify.com/api/chennai/users/${User_Id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setUserData(response.data);
        } else {
          setError("No user data found.");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Failed to load user profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Loading profile...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen text-red-600">
        {error}
      </div>
    );
  }

  return (
    
    <div className="min-h-screen bg-gray-100">
    {/* NAVBAR */}
    <Navbar />

 <button
        onClick={() => navigate(-1)}
        className="flex items-center text-black font-semibold mb-6 pl-20 pr-5 pt-6 "
      >
        <ArrowLeft className="mr-2 h-5 w-5 " />
        Back to dashboard
      </button>

    {/* MAIN CONTENT */}
    <div className="max-w-6xl mx-auto p-6 pt-10 mt-9">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

        

        {/* LEFT BOX */}
        <div className="bg-white border rounded-2xl shadow-sm p-10 flex flex-col items-center min-h-[380px]">
          <div className="w-28 h-28 rounded-full bg-gradient-to-b from-blue-400 to-blue-600 flex items-center justify-center">
            <User className="text-white w-14 h-14" />
          </div>

          <h2 className="mt-4 text-2xl font-semibold text-gray-900">
            {userData?.userFirstname} {userData?.userLastname}
          </h2>

          <p className="text-gray-500 text-sm">{userData?.roleType}</p>
        </div>

        {/* RIGHT BOX */}
        <div className="bg-white border rounded-2xl shadow-sm p-10 min-h-[380px]">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-left">
            Personal Information
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 text-sm text-gray-700">

            <div>
              <p className="font-medium flex items-center gap-2">
                <User className="w-4 h-4 text-black " /> First Name
              </p>
              <p className="text-gray-600 mt-2 text-left pl-6">{userData?.userFirstname || "—"}</p>
            </div>

            <div>
              <p className="font-medium flex items-center gap-2">
                <User className="w-4 h-4 text-black" /> Last Name
              </p>
              <p className="text-gray-600 mt-2 text-left pl-6">{userData?.userLastname || "—"}</p>
            </div>

            <div>
              <p className="font-medium flex items-center gap-2">
                <Mail className="w-4 h-4 text-black" /> Email ID
              </p>
              <p className="text-gray-600 mt-2 text-left pl-6">{userData?.userEmail || "—"}</p>
            </div>

            <div>
              <p className="font-medium flex items-center gap-2">
                <Phone className="w-4 h-4 text-black" /> Phone Number
              </p>
              <p className="text-gray-600 mt-2 text-left pl-6">{userData?.userPhoneno || "—"}</p>
            </div>

            <div className="sm:col-span-2">
              <p className="font-medium flex items-center gap-2">
                <MapPin className="w-4 h-4 text-black" /> Address
              </p>
              <p className="text-gray-600 mt-2 text-left pl-6">{userData?.address || "—"}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  );
};

export default ChennaiProfile;
